import React from 'react';
import Input from '../../../components/ui/Input';

function S3SourceFields({ values, onFieldChange }) {
  return (
    <div className="space-y-4 rounded-xl border border-surface-border bg-slate-50/60 p-4">
      <Input
        id="kb_s3_url"
        label="Link do bucket S3"
        value={values.s3Url}
        onChange={onFieldChange('s3Url')}
        placeholder="s3://file-to-text-development/teste/"
        required
      />
      <Input
        id="kb_s3_access_key"
        label="Access Key"
        value={values.awsAccessKeyId}
        onChange={onFieldChange('awsAccessKeyId')}
        required
        autoComplete="off"
      />
      <Input
        id="kb_s3_secret_key"
        label="Secret Key"
        type="password"
        value={values.awsSecretAccessKey}
        onChange={onFieldChange('awsSecretAccessKey')}
        required
        autoComplete="new-password"
      />
    </div>
  );
}

export default S3SourceFields;
